import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { NotFound } from 'app/components/not-found';
import { MlTraining } from 'features/seam/ml/ml-training';

import { Dashboard } from './dashboard';
import { Kanban } from './kanban';
import { MetricsRouter } from './metrics/metrics-router';
import { RequestRouter } from './request/request-router';
import { RequestForm } from './request-form';
import { SeamHeader } from './seam-header';
import { TaggingQuality } from './tagging-quality';

export class Seam extends React.Component {
    public render(): React.ReactNode {
        return (
            <Switch>
                <Route path='/seam/dashboard'>
                    <SeamHeader />
                    <Dashboard />
                </Route>
                <Route path='/seam/kanban'>
                    <SeamHeader />
                    <Kanban />
                </Route>
                <Route path='/seam/metrics'>
                    <SeamHeader />
                    <MetricsRouter />
                </Route>
                <Route path='/seam/tagging'>
                    <SeamHeader />
                    <MlTraining />
                </Route>
                <Route path='/seam/labeling'>
                    <SeamHeader />
                    <TaggingQuality />
                </Route>
                <Route path='/seam/request/new'>
                    <SeamHeader />
                    <RequestForm />
                </Route>
                <Route path='/seam/request/:id'>
                    <RequestRouter />
                </Route>
                <Route exact path='/seam'>
                    <Redirect to='/seam/dashboard' />
                </Route>
                <Route path='*'>
                    <SeamHeader />
                    <NotFound />
                </Route>
            </Switch>
        );
    }
}
